module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "businesscooperation"
  }, [_c('banner-bg', {
    attrs: {
      "title": "驱动合作伙伴不断赢得成功",
      "subtitle": "赋能赛事的价值",
      "src": require('@/assets/images/mainindex/cooperation-banner@2x.png')
    }
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "businesscooperation_list container_wrap",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  }, _vm._l((6), function(item, index) {
    return (false) ? _c('div', {
      key: index,
      staticClass: "businesscooperation_list_item_container"
    }, [_c('div', {
      staticClass: "businesscooperation_list_item"
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/mainindex/pic-zhaoshang@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "businesscooperation_list_item_title"
    }, [_vm._v("\n              分站赛招商方案\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "businesscooperation_list_item_subtitle"
    }, [_vm._v("\n              全国啦啦操分站赛是中国影响力最大的赛事之一\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "businesscooperation_list_item_tips"
    }, [_vm._v("\n              冠名 ｜秩序册 ｜ 巨幅海报 ｜ APP ｜ 央视\n            ")]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _vm._m(0, true)], 1)]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "partner_title"
  }, [_vm._v("合作伙伴")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container_wrap partner-box"
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'CmsDetail',query:{id:row.id}}"
      }],
      staticClass: "partner-li",
      style: ('width: ' + (100 / _vm.list.length - 1) + '%')
    }, [_c('img', {
      attrs: {
        "src": row.pic_url
      }
    })])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "businesscooperation_list_item_tags"
  }, [_c('div', {
    staticClass: "businesscooperation_list_item_tags_el"
  }, [_c('div', {
    staticClass: "businesscooperation_list_item_tags_el_num"
  }, [_vm._v("\n                  228,737\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "businesscooperation_list_item_tags_el_font"
  }, [_vm._v("\n                  人次\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "businesscooperation_list_item_tags_el"
  }, [_c('div', {
    staticClass: "businesscooperation_list_item_tags_el_num"
  }, [_vm._v("32")]), _vm._v(" "), _c('div', {
    staticClass: "businesscooperation_list_item_tags_el_font"
  }, [_vm._v("\n                  媒体\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "businesscooperation_list_item_tags_el"
  }, [_c('div', {
    staticClass: "businesscooperation_list_item_tags_el_num"
  }, [_vm._v("992")]), _vm._v(" "), _c('div', {
    staticClass: "businesscooperation_list_item_tags_el_font"
  }, [_vm._v("\n                  报道\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472ad6d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/BusinessCooperation.vue
// module id = 1434
// module chunks = 0